<template>
     <div class="ui error message" v-if="errors.length > 0">
        <ul class="list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: [
        "errors"
    ]
}
</script>